module.exports = __webpack_public_path__ + "img/reports_green.cac56f14.svg";